import { Component, OnInit, Input, EventEmitter, ChangeDetectorRef, ViewRef, DoCheck, ChangeDetectionStrategy } from '@angular/core';
import { Options } from "@angular-slider/ngx-slider";
import { FieldType } from "@ngx-formly/core";
import { restore } from "./../../../../assets/json/restoreTooltip.en";
import { AppStateService } from "src/app/core-module/services/app-state.service";
import { AloAocStateService } from "../../../core-module/services/state/alo-aoc-state.service";
import { FeatureDefaultsStateService } from "../../../core-module/services/state/feature-defaults-state.service";

@Component({
  standalone: false,
  selector: "app-startuptime",
  templateUrl: "./startuptime.component.html",
  styleUrls: ["./startuptime.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StartuptimeComponent extends FieldType implements OnInit {
  isEdited: LegacyAny;
  @Input() field;
  valOptions: Options = {};
  floorValue;
  ceilValue;
  defaultValue;
  enableFeatureCheckbox;
  isResetDisabled;
  manualRefresh: EventEmitter<void> = new EventEmitter<void>();
  sliderValue;
  textboxValue;
  textboxValueDisplay;  // Display value for textbox (shows what user types)
  defaultColor = true;
  deviceName;
  isHidden;
  isAocEnabled;
  isEnableFeature;
  inputError = false;
  quickConfigvalue;
  quickConfigCustomCSS;
  setQuickConfig;
  restoreText = restore;
  booleanValue = true;
  fileResponse: LegacyAny;
  unit = 'ms'; // Default unit
  constructor(
    private ref: ChangeDetectorRef, private appState: AppStateService,
    private featureDefaults: FeatureDefaultsStateService,
    private aloAoc: AloAocStateService
  ) {
    super();
  }

  ngOnInit() {
    this.isEdited = false;
    this.featureDefaults.getStartupDefaultValue.subscribe((response) => {
      this.defaultValue = response;
      this.textboxValue = response;
      this.textboxValueDisplay = response;
      this.sliderValue = response;
      this.inputError = false;
      this.valOptions = { ...this.valOptions, disabled: false };
      const mode = this.appState.getModes();
      // if (mode === 'Standard') {
        //this.valueChanged(response);
      //}
      this.manualRefresh.emit();
      this.ref.markForCheck();
    });

    // Guard: If schema not loaded, initialize with safe defaults and return
    if (!this.field || !this.field.properties || !this.field.properties.AdjustableStartupTime) {
      this.valOptions = { floor: 0, ceil: 100 };
      return;
    }

    this.floorValue = this.field.properties.AdjustableStartupTime.minimum;
    this.ceilValue = this.field.properties.AdjustableStartupTime.maximum;
    this.defaultValue = this.field.properties.AdjustableStartupTime.default;
    
    // Get unit from schema, default to 'ms' if not specified
    // Convert 'second' to 's' for display, 'millisecond' to 'ms'
    const schemaUnit = this.field.properties.AdjustableStartupTime.unit;
    if (schemaUnit === 'second') {
      this.unit = 's';
    } else if (schemaUnit === 'millisecond') {
      this.unit = 'ms';
    } else {
      // Use the unit as-is if it's already abbreviated, or default to 'ms'
      this.unit = schemaUnit || 'ms';
    }
    if (this.field.properties.length === 1) {
      this.enableFeatureCheckbox = false;
      this.isResetDisabled = true;
    } else {
      this.isResetDisabled = false;
    }
    this.valOptions = {
      floor: this.floorValue,
      ceil: this.ceilValue,
      disabled: false,
    };
    this.textboxValue = this.defaultValue;
    this.textboxValueDisplay = this.defaultValue;
    this.sliderValue = this.defaultValue;
    this.valueChanged(this.textboxValue);

    // Use centralized method to get feature data
    // This automatically prioritizes SaveSetData over ConfigurationData
    const astData = this.appState.getFeatureData('AST') || this.appState.getFeatureData('Ast');

    const unSelectedFeat = this.appState.getUnSelectedFeatConfig();

    let isConfigEdited = false;
    let featIndex: number = 0;
    if (unSelectedFeat != null) {
      unSelectedFeat.forEach((element) => {
        if (element != null && element["featureName"] != null && element["featureName"].toString().toUpperCase() === "AST") {
          isConfigEdited = true;
          this.textboxValue =
            element["featureParameters"][0]["AdjustableStartupTime"];
          this.sliderValue = this.textboxValue;
          this.sliderEvent(this.sliderValue);
          unSelectedFeat.splice(featIndex, 1);
          this.appState.setUnSelectedFeatConfig(unSelectedFeat);
        } else {
          featIndex++;
        }
      });
    }

    // Load feature data if not from configure flow
    if (!isConfigEdited && astData) {
      // Use valueChanged so that empty/invalid persisted values
      // correctly restore the error state (red box) after page refresh.
      this.valueChanged(astData["AdjustableStartupTime"]);
    }
    this.aloAoc.getquickConfig.subscribe((data) => {
      if (data === "quickConfig") {
        this.quickConfigvalue = true;
        this.quickConfigCustomCSS = "quick-custom-inputbox";
        this.setQuickConfig = "quickConfig";
      } else {
        this.quickConfigvalue = false;
        this.quickConfigCustomCSS = "custom-inputbox";
        this.setQuickConfig = "standard";
      }
      setTimeout(() => {
        if (this.ref && !(this.ref as ViewRef).destroyed) {
          this.ref.detectChanges();
        }
      });
    });
    this.startupSliderClickEvent(this.textboxValue);
    this.isEdited = true;
    // this.aloAoc.sendStartupValidData("valid");
  }
  setConfigurationData(value, keyVal) {
    // Use centralized method to save feature data
    // This automatically saves to both ConfigurationData and SaveSetData
    const touchDimObj = Object.assign({ ["AdjustableStartupTime"]: value });
    this.appState.setFeatureData(keyVal, touchDimObj);
  }
  startupSliderClickEvent(val) {
    this.aloAoc.startupSliderClickEvent(val);
    if (this.isEdited) {
      this.setConfigurationData(val, "AST");
    }
  }
  sliderEvent(val) {
    this.inputError = false;
    this.textboxValue = val;
    this.textboxValueDisplay = val;
    this.sliderValue = val;
    this.startupSliderClickEvent(val);
    
    if (
      this.defaultValue === Number(this.sliderValue) &&
      this.defaultValue === this.textboxValue
    ) {
      this.defaultColor = true;
    } else {
      this.defaultColor = false;
    }
    
    this.aloAoc.sendStartupValidData("valid");
    this.featureDefaults.setStartupDefaultColor(this.defaultColor);
    this.ref.detectChanges();
  }

  numberOnly(event): boolean {
    const charCode = event.which ? event.which : event.keyCode;
return !(charCode > 31 && (charCode < 48 || charCode > 57));
  }

  valueChanged(value) {
    // Always update display value to show what user typed
    this.textboxValueDisplay = value;
    
    if (value === "" || value === "-0") {
      // Empty or invalid input - keep slider at current position
      this.inputError = true;
      this.aloAoc.sendStartupValidData("invalid");
      this.defaultColor = false;
      this.textboxValue = value;
    } else if (value > this.ceilValue) {
      // Over max - move slider to max to show boundary
      this.inputError = true;
      this.aloAoc.sendStartupValidData("invalid");
      this.defaultColor = false;
      this.sliderValue = this.ceilValue;
      this.textboxValue = value;
    } else if (value < this.floorValue) {
      // Under min - move slider to min to show boundary
      this.inputError = true;
      this.aloAoc.sendStartupValidData("invalid");
      this.defaultColor = false;
      this.sliderValue = this.floorValue;
      this.textboxValue = value;
    } else {
      // Valid value - update slider and save
      this.inputError = false;
      this.aloAoc.sendStartupValidData("valid");
      this.sliderValue = Number(value);
      this.textboxValue = value;
      this.startupSliderClickEvent(this.textboxValue);
    }
    
    if (this.field.properties.length === 1) {
      this.defaultColor = true;
    } else {
      // Only check if value equals default when we have a valid value
      if (Number(this.textboxValue) === this.defaultValue && !this.inputError) {
        this.defaultColor = true;
      } else if (Number(this.textboxValue) !== this.defaultValue) {
        this.defaultColor = false;
      }
    }
    this.featureDefaults.setStartupDefaultColor(this.defaultColor);
    this.ref.detectChanges();
  }

  restoreDefault() {
    this.sliderValue = this.defaultValue;
    this.textboxValue = this.defaultValue;
    this.textboxValueDisplay = this.defaultValue;
    this.inputError = false;
    this.aloAoc.sendStartupValidData("valid");
    this.defaultColor = true;
    if (this.field.properties.length === 1) {
      this.isResetDisabled = true;
    } else {
      this.isResetDisabled = false;
    }
    this.startupSliderClickEvent(this.textboxValue);
    this.featureDefaults.setStartupDefaultColor(this.defaultColor);
    this.ref.detectChanges();
  }

  sliderValueChange(value) {
    this.sliderEvent(value);
  }

  enableFeature(checked: LegacyAny) {

  }

  getSliderSafeValue(value: number, min: number, max: number): number {
    if (value === null || value === undefined || isNaN(value)) {
      return min;
    }
    if (value < min) {
      return min;
    }
    if (value > max) {
      return max;
    }
    return value;
  }
}

